import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: center;
    height: 100%;
`;

export const Text = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 700;
        padding-right: 1rem;
        flex: 0 0 auto;
        width: 55%;
        align-self: center;

        @media ${theme.breakpoints.smallLarge.media} {
            padding-right: 1.5rem;
            font-size: 1.5rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    position: relative;
    width: 45%;
    flex: 0 0 auto;
`;
